<template>
    <div class="w-full">
        <el-card class="m-6" shadow="none">
            <div slot="header" class="clearfix">
                <span class="leading-loose">{{ cardTitle }}</span>
                    <el-date-picker
                            class="float-right"
                            v-model="month"
                            type="month"
                            placeholder="Pick a month"
                            ref="monthInput"
                            :clearable="false"
                            @change="dateChanged">
                    </el-date-picker>
            </div>

            <el-table :data="tableData"
                      class="w-full"
                      @sort-change="sort"
                      :default-sort = "{prop: 'lastCreated', order: 'descending'}">

                <!-- Title -->
                <el-table-column
                        prop="Naam"
                        label="Naam">
                        <template slot-scope="scope">
                            {{ scope.row.firstName }} {{ scope.row.lastName }}
                        </template>
                </el-table-column>

                <!-- Nieuw -->
                <el-table-column
                        prop="inProgress"
                        label="Nieuw"
                        width="120">
                </el-table-column>

                <!-- Bevestigd -->
                <el-table-column
                        prop="confirmed"
                        label="Bevestigd"
                        width="120">
                </el-table-column>

                <!-- Nieuw -->
                <el-table-column
                        prop="paid"
                        label="Betaald"
                        width="120">
                </el-table-column>

                <!-- Laatste update -->
                <el-table-column
                        prop="lastCreated"
                        label="Laatste update">
                    <template slot-scope="scope">
                        {{ moment(scope.row.lastCreated).format('DD-MM-YYYY HH:mm') }}
                    </template>
                </el-table-column>

                <!-- Operations column -->
                <el-table-column label="Operaties">
                    <template slot-scope="scope">
                        <el-button
                                size="mini"
                                @click="viewPerformances(scope.$index, scope.row)">Bekijken</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination class="mt-6"
                           layout="total"
                           :total="totalElements">
            </el-pagination>
        </el-card>

        <performances-overview-dialog ref="viewDialog" :branch-options="branchOptions"></performances-overview-dialog>
    </div>
</template>

<script>
    import PerformancesOverviewDialog from "./dialogs/PerformancesOverviewDialog";
    import moment from 'moment'

    export default {
        name: "Performances",
        components: {PerformancesOverviewDialog},
        data() {
            return {
                // Title
                cardTitle: "Prestaties",
                itemName: "prestatie",
                month: new Date(),
                branchOptions: this.getBranchOptions(),

                // Table data
                tableData: this.getList(),
                numPages: 1,
                pageSize: 10,
                currentPage: 1,
                pageSizes: [10, 20, 50],
                totalElements: 0
            }
        },
        methods: {
            handleSizeChange() {
                this.getList();
            },
            handleCurrentChange() {
                this.getList();
            },
            updateList() {
                this.getList();
            },
            dateChanged() {
                this.getList();
            },
            viewPerformances(index, row) {
                this.$refs.viewDialog.show(row, this.getMonth.firstDay, this.getMonth.lastDay);
            },
            sort (props) {
                if (props.order === 'ascending') {
                    this.sortDir = 'ASC'
                } else {
                    this.sortDir = 'DESC'
                }
                this.sortBy = props.prop
                this.getList()
            },
            getBranchOptions() {
                const that = this
                this.$http.get('admin/branches/list').then((response) => {
                    this.branchOptions = response.data;
                }).catch(function (error) {
                    if(error.response.status === 403) {
                        that.$router.replace({ name: 'Login', force: true });
                    }
                    this.branchOptions = [];
                    console.log(error)
                })
            },
            getList() {
                const that = this
                let params = {}
                params['numPerPage'] = this.pageSize
                params['page'] = this.currentPage
                if (this.sortDir != null && this.sortBy != null) {
                    params['sortBy'] = this.sortBy
                    params['sortDir'] = this.sortDir
                }
                if(this.getMonth) {
                    this.$http.get(`admin/sessions/grouped?startDate=${this.getMonth.firstDay}&endDate=${this.getMonth.lastDay}`, {
                        params: params
                    }).then((response) => {
                        const listResponse = response.data
                        this.tableData = listResponse;
                        this.totalElements = response.data.length
                    }).catch(function (error) {
                        if(error.response.status === 403) {
                            that.$router.replace({ name: 'Login', force: true });
                        }
                        console.log(error)
                    })
                }
            },
            capitalize(string) {
                return string.charAt(0).toUpperCase() + string.slice(1);
            }
        },
        mounted() {
            this.getList()
        },
        computed: {
            getMonth() {
                const y = this.month.getFullYear()
                const m = this.month.getMonth()
                let firstDay = new Date(y, m, 1);
                let lastDay = new Date(y, m + 1, 0);

                firstDay = moment(firstDay).format("D-MM-YYYY")
                lastDay = moment(lastDay).format("D-MM-YYYY")

                return {
                    firstDay: firstDay,
                    lastDay: lastDay
                };
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/dashboard/prestations/Performances.vue